import {withStyles} from "@material-ui/core/styles";
import Color from "../utils/colors";
import Switch from "@material-ui/core/Switch";

const ColoredSwitch = withStyles({
  switchBase: {
    color: Color.secondary,
    '&$checked': {
      color: Color.green,
    },
    '&$checked + $track': {
      backgroundColor: 'darkgrey',
    },
  },
  checked: {},
  track: {},
})(Switch);

export default ColoredSwitch;
